import {
  CommandStep,
  isMatrixCommandStep,
  isParallelCommandStep,
  Step,
  TriggerStep,
} from "~/lib/pipeline";
import { Job, CommandJob, RetryableJob, TriggerJob } from "~/components/build/Show/lib/types";
import { ParallelStepJobs } from "~/components/build/Show/components/StepDrawer/ParallelStepJobs";
import { MatrixStepList } from "~/components/build/Show/components/StepDrawer/MatrixStepList";
import { CommandJobDetails } from "~/components/build/Show/components/StepDrawer/CommandJobDetails";
import { TriggerJobDetails } from "~/components/build/Show/components/StepDrawer/TriggerJobDetails";

export function shouldRenderStepDrawer(step: Step): step is CommandStep | TriggerStep {
  return step.type === "trigger" || step.type === "command";
}

export function shouldRenderJobDrawer(job: Job): job is CommandJob | TriggerJob {
  return job.type === "script" || job.type === "trigger";
}

export function StepContent({ step }: { step: CommandStep | TriggerStep }) {
  if (step.type === "trigger") {
    return <TriggerJobDetails />;
  }

  if (isParallelCommandStep(step)) {
    return <ParallelStepJobs />;
  }

  if (isMatrixCommandStep(step)) {
    return <MatrixStepList />;
  }

  return <CommandJobDetails />;
}

export function JobContent({ job }: { job: CommandJob | TriggerJob }) {
  if (job.type === "script") {
    return <CommandJobDetails />;
  }

  return <TriggerJobDetails />;
}

/**
 * Resolve the "current" job for a step variant.
 * Returns the most recent job for trigger/single-command steps,
 * undefined for parallel/matrix steps (which show aggregate views).
 */
export function resolveCurrentJob(step: Step, jobs: Job[]): RetryableJob | undefined {
  if (step.type === "trigger") {
    return jobs[jobs.length - 1] as TriggerJob | undefined;
  }

  if (step.type !== "command") {
    return undefined;
  }

  if (isParallelCommandStep(step) || isMatrixCommandStep(step)) {
    return undefined;
  }

  return jobs[jobs.length - 1] as CommandJob | undefined;
}
